// extracted by mini-css-extract-plugin
export default {"aspectScore":"aspectScore_Header-module_z61G7","aspectName":"aspectName_Header-module_rrxjH","comparisonText":"comparisonText_Header-module_QafXD"};